import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKeyboard1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V22H21V3H3ZM6.5 4.5H4.5V20.5H8V13.5H6.5V4.5ZM9.5 20.5H14.5V13.5H13V4.5H11V13.5H9.5V20.5ZM17.5 4.5V13.5H16V20.5H19.5V4.5H17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboard1;
